const es = require('./es.json');

export default {
  es,
};
